/**
* Init Vue
*/

import { createApp } from 'vue';

import CardSelector from './components/CardSelector';
import EarningCalculator from './components/EarningCalculator';
import RedeemPoints from './components/RedeemPoints';
import ExploreOffers from './components/ExploreOffers';
import EarnMore from './components/EarnMore';
import MomentsCards from './components/MomentsCards';
import EnjoyBenefits from './components/EnjoyBenefits';
import EnjoyBenefitsHeading from './components/EnjoyBenefitsHeading';
import CardTerms from './components/CardTerms';
import AlertBanner from './components/AlertBanner';

import { createPinia } from 'pinia';

const app = createApp({});

app.component('CardSelector', CardSelector);
app.component('EarningCalculator', EarningCalculator);
app.component('RedeemPoints', RedeemPoints);
app.component('ExploreOffers', ExploreOffers);
app.component('EarnMore', EarnMore);
app.component('MomentsCards', MomentsCards);
app.component('EnjoyBenefits', EnjoyBenefits);
app.component('EnjoyBenefitsHeading', EnjoyBenefitsHeading);
app.component('CardTerms', CardTerms);
app.component('AlertBanner', AlertBanner);

app.use(createPinia());
app.mount('#app');
